import { render, staticRenderFns } from "./scrollable-sidesheet.vue?vue&type=template&id=2b4d1e5c&scoped=true&"
import script from "./scrollable-sidesheet.vue?vue&type=script&lang=js&"
export * from "./scrollable-sidesheet.vue?vue&type=script&lang=js&"
import style0 from "./scrollable-sidesheet.vue?vue&type=style&index=0&id=2b4d1e5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4d1e5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b4d1e5c')) {
      api.createRecord('2b4d1e5c', component.options)
    } else {
      api.reload('2b4d1e5c', component.options)
    }
    module.hot.accept("./scrollable-sidesheet.vue?vue&type=template&id=2b4d1e5c&scoped=true&", function () {
      api.rerender('2b4d1e5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scrollable-sidesheet.vue"
export default component.exports